import { render } from "./FullReport.vue?vue&type=template&id=15d65717&ts=true"
import script from "./FullReport.vue?vue&type=script&lang=ts"
export * from "./FullReport.vue?vue&type=script&lang=ts"

import "./FullReport.vue?vue&type=style&index=0&id=15d65717&lang=scss"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__